import { IsNotEmpty, IsString } from 'class-validator';
import { Entity } from '../entity/entity.js';

export class ClientStreamEntity extends Entity
{
    @IsString()
    @IsNotEmpty()
    name!: string;
}